import ViewNavegacao from './PagesComponents/ViewNavegacao.vue';
import ViewAcessosCustomers from './PagesComponents/ViewAcessosCustomers.vue';
import ViewMostAccessed from './PagesComponents/ViewMostAccessed.vue';
import ViewIndicadores from './ViewIndicadores.vue';

const name = 'dash-indicadores'
const path = '/dash-indicadores';

export default [
  {
    path: `${path}`,
    name: `${name}`,
    component: () => import('./HomeIndicadores.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `/customers-registrados-logados`,
    name: `customers-registrados-logados`,
    component: ViewNavegacao,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `/acessos-customers`,
    name: `acessos-customers`,
    component: ViewAcessosCustomers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `/paginas-mais-acessadas`,
    name: `paginas-mais-acessadas`,
    component: ViewMostAccessed,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `/indicadores-financeiros`,
    name: `indicadores-financeiros`,
    component: ViewIndicadores,
    meta: {
      requiresAuth: true,
    },
  },
];